import React from "react";
import GrComponentFactory from "../../../gr_component_factory";
import GrPropTypes from "../../../shared/gr_prop_types";
import SocialUpdate from "../../social_update";
import CommunityAnswerDetails from "../community_answer_details";

export default GrComponentFactory.createClass({
  displayName: "AuthorAnswerNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.shape(GrPropTypes.communityAnswer()),
  },

  renderAuthorQALink() {
    return <a href={this.props.resource.communityQuestion.authorQuestionsUrl}>
             View all Author Q&A
           </a>;
  },

  render() {
    const body = <CommunityAnswerDetails {...this.props.resource} />;

    return (
      <SocialUpdate
        {...this.props}
        header={<span>answered a question</span>}
        body={body}
        additionalFooterLinks={[this.renderAuthorQALink()]}
      />
    );
  },
});
